import { ApiChallenge } from '~/api/v1/challenges/get-type';
import { ApiCompetition } from '~/api/v1/organizations/[id]/competitions/get';
import { CardProject } from '~/components/Card/CardProject';
import { isNotEmpty } from '~/utils/array';

type Props = {
  competitions?: ApiCompetition[];
  challenges?: ApiChallenge[];
};

export function TabPanelProject({ competitions, challenges }: Props) {
  const statusVotingCompetitions = competitions?.filter(
    (competition) => competition.status === 'voting',
  );
  const statusOpenCompetitions = competitions?.filter(
    (competition) => competition.status === 'open',
  );
  const statusFinishedCompetitions = competitions?.filter(
    (competition) => competition.status === 'finished',
  );
  const statusOpenProjects = [...(statusOpenCompetitions || []), ...(challenges || [])];

  return (
    <div className='flex flex-col gap-xxl__sp py-10 lg:mx-auto lg:max-w-[960px] lg:gap-xxl lg:py-16'>
      {/* 投票中のプロジェクト */}
      {isNotEmpty(statusVotingCompetitions) && (
        <div className='flex w-full flex-col gap-8'>
          <h2 className='text-title-medium__sp font-bold text-accent lg:text-title-medium lg:font-bold'>
            投票中のプロジェクト
            {/* TODO: 新規APIが作成した時点で置き換え */}
          </h2>
          <ul className='flex flex-col gap-4 lg:flex-row lg:flex-wrap'>
            {statusVotingCompetitions.map((competition) => (
              <li key={`competition-status-voting-${competition.id}`}>
                <CardProject
                  title={competition.title ?? ''}
                  src={competition.cover ?? '/dummy/900-600.png'}
                  link={`/comps/${competition.id}`}
                  label={'わくわく寄付コンペ'}
                />
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* 募集中のプロジェクト */}
      {isNotEmpty(statusOpenProjects) && (
        <div className='flex w-full flex-col gap-8'>
          <h2 className='text-title-medium__sp font-bold text-accent lg:text-title-medium lg:font-bold'>
            募集中のプロジェクト
            {/* TODO: 新規APIが作成した時点で置き換え */}
          </h2>
          <ul className='grid grid-cols-[repeat(auto-fill,304px)] justify-center gap-4'>
            {statusOpenProjects.map((project) => {
              const isCompetition = 'status' in project;
              const coverImage = isCompetition
                ? project.cover
                : project.images[0] ?? '/dummy/900-600.png';

              return (
                <li className='w-full max-w-[304px]' key={`project-status-open-${project.id}`}>
                  <CardProject
                    title={project.title ?? ''}
                    src={coverImage}
                    link={isCompetition ? `/comps/${project.id}` : `/challenges/${project.id}`}
                    label={isCompetition ? 'わくわく寄付コンペ' : 'チャレマ'}
                  />
                </li>
              );
            })}
          </ul>
        </div>
      )}

      {/* 過去のプロジェクト */}
      {isNotEmpty(statusFinishedCompetitions) && (
        <div className='flex w-full flex-col gap-8'>
          <h2 className='text-title-medium__sp font-bold text-accent lg:text-title-medium lg:font-bold'>
            過去のプロジェクト
            {/* TODO: 新規APIが作成した時点で置き換え */}
          </h2>
          <ul className='grid grid-cols-[repeat(auto-fill,304px)] justify-center gap-4'>
            {statusFinishedCompetitions.map((competition) => (
              <li
                className='w-full max-w-[304px]'
                key={`competition-status-finished-${competition.id}`}
              >
                <CardProject
                  title={competition.title ?? ''}
                  src={competition.cover ?? '/dummy/900-600.png'}
                  link={`/comps/${competition.id}`}
                  label={'わくわく寄付コンペ'}
                />
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
